
import {Component, Prop, Vue} from "vue-property-decorator";
import LogElement from "@/components/logs/LogElement.vue";

export const MAX_LOGS_DISPLAYED: number = 5;

@Component({
    components: {
        LogElement,
    },
})
export default class LastLogs extends Vue {

    @Prop({default: null})
    public logs: any;

    @Prop({default: false})
    public loading: any;

    get lastLogs(): any[] {
        return this.logs?.rows?.slice(0, MAX_LOGS_DISPLAYED);
    }

    get moreLogs(): number {
        return this.logs?.count - this.lastLogs?.length;
    }
}
